import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

const Container = styled.div`
  background-color: white;
  padding: 12px 12px 0px;
  margin: 8px 0;

  .btn {
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CellComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    return <Container className={this.props.className}>{this.props.children}</Container>;
  }
}

CellComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Cell = compose(
  withConnect,
  withRouter,
)(CellComp);
